import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';

const blackmilkclothingSizeOptions = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '20',
  'ONESIZE',
];

export const blackmilkclothingUsShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes: blackmilkclothingSizeOptions }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: 'e690c837406c43ba999a7fe5f15d66d1',
      [BuilderSections.TopbarContent]: 'd75e2089c3ec4caeaa0de2c0f0ece278',
    },
  },
};
